import { FlexibleDatesRoundTripProvider } from './FlexibleDatesRoundTripProvider';

export default FlexibleDatesRoundTripProvider;
